export default __webpack_public_path__ + "static/media/default.c1a22050709f14c9ee7b0203fb42009b.svg";